module.exports = __webpack_public_path__ + "static/img/cuelistWHITE.6170c5e.png";


//////////////////
// WEBPACK FOOTER
// ./sample/assets/img/cuelistWHITE.png
// module id = 579
// module chunks = 2